'use client'

import type { ReactNode } from 'react'
import { formatNotificationFeedPreview } from '@/lib/utils/notification'
import { notificationText, notificationUnread } from './styles'

export function renderUnreadDot(visible: boolean): ReactNode {
  if (!visible) return null
  return (
    <span
      className={`absolute end-0 top-0 size-[calc(6*var(--vw))] rounded-full ${notificationUnread}`}
    />
  )
}

export function renderFeedBodyText(body: string | null): ReactNode {
  const preview = formatNotificationFeedPreview(body)
  if (!preview) return null
  return (
    <span
      className={[
        'line-clamp-2 h-[calc(32*var(--vw))] w-full overflow-hidden',
        'text-[calc(12*var(--vw))] font-normal leading-[calc(16*var(--vw))]',
        notificationText.disabled,
      ].join(' ')}
    >
      <span>{preview}</span>
    </span>
  )
}
